module.exports = __webpack_public_path__ + "static/media/svg_3_2_1_18L_36R.b7543fc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/03/02/assets/svg_3_2_1_18L_36R.svg
// module id = 796
// module chunks = 0